/**
 * INNFLOW DESIGN SYSTEM V2.0 - EmptyState Component
 * 
 * Componente para estados vazios
 * 
 * @version 2.0.0
 * @author INNFLOW Design Team
 */

import React from 'react';
import { Inbox } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Icon } from '@/components/atoms/Icon';
import './EmptyState.css';

export interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  action?: React.ReactNode;
  className?: string;
}

/**
 * EmptyState - Componente para estados vazios
 * 
 * Textos em PT-BR por padrão
 */
export const EmptyState: React.FC<EmptyStateProps> = ({
  icon,
  title,
  description,
  action,
  className,
}) => {
  return (
    <div className={cn('innflow-empty', className)}>
      <div className="innflow-empty__icon">
        {icon || <Icon name="Inbox" size="lg" color="muted" />}
      </div>
      <h3 className="innflow-empty__title">{title}</h3>
      {description && <p className="innflow-empty__description">{description}</p>}
      {action && <div className="innflow-empty__action">{action}</div>}
    </div>
  );
};

export default EmptyState;
